<template>
    <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M1 20v-2h6v2H1zM1 6V4h22v2H1zm0 7v-2h14v2H1z" />
    </svg>
</template>

<script>
export default {
    name: "SortIcon",
};
</script>
